import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../../shared';
import { MlmInvitationContainerModel } from "../../../../../../models/aggregates/erp/mlm-admin";

@Injectable({ providedIn: 'root' })
export class MlmInvitationService extends BaseApiTemplateService<MlmInvitationContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'mlm/invitation';
  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX  + 'mlm/invitation';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'mlm/invitation';
    this.httpClient = theHttp;
  }


}

